import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=80d48e9e&scoped=true&"
import script from "./NextSteps.vue?vue&type=script&lang=js&"
export * from "./NextSteps.vue?vue&type=script&lang=js&"
import style0 from "./NextSteps.vue?vue&type=style&index=0&id=80d48e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d48e9e",
  null
  
)

export default component.exports